import { ImpactClaimsProvider } from 'components/Contexts';
import ModalContent from 'components/Integrations/JourneyWidget/ModalContent';
import Preview from 'components/Integrations/JourneyWidget/Preview';
import IntegrationStackedContent from 'components/Integrations/Shared/IntegrationStackedContent';
import { useBrowser } from 'hooks';
import React, { Fragment, useState } from 'react';
import Modal from 'react-modal';
import { IntegrationAnalyticsProvider } from '../Shared/IntegrationAnalyticsProvider';
import ImpactClaimsContainer from './ImpactClaimsContainer';
import { ModalProvider } from 'styled-react-modal';
import { styled } from 'styled-components';
const SpecialModalBackground = styled.div `
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  align-items: center;
  justify-content: center;
  z-index: 9999999;
`;
const customStyles = {
    overlay: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    content: {
        left: 0,
        right: 0,
        /** Transform was braking iOS view somehow, so fixed it with display flex */
        transform: 'none',
        width: '100%',
        maxWidth: 'calc(100% - 32px)',
        height: '700px',
        maxHeight: 'calc(100vh - 140px)',
        /** Additional margin for safari browser */
        marginBottom: 60,
        backgroundColor: '#fff',
        border: 'none',
        padding: 0,
        position: 'relative',
        WebkitOverflowScrolling: 'touch',
        overflow: 'visible',
    },
};
Modal.setAppElement('#st-store-widget');
const JourneyWidgetContainer = ({ supplyChain, locale, productId, previewType, gaTrackingId, impactClaims, latestBatch, showClaims = false, }) => {
    const [isOpen, setIsOpen] = useState(false);
    const toggleModal = () => {
        setIsOpen(!isOpen);
    };
    const { isMobile } = useBrowser();
    return (React.createElement(Fragment, null,
        showClaims && (React.createElement(ImpactClaimsProvider, { impactClaims: impactClaims },
            React.createElement(ImpactClaimsContainer, null))),
        React.createElement(Preview, { type: previewType, onClick: toggleModal, locale: locale, supplyChain: supplyChain, productId: productId, latestBatch: latestBatch }),
        React.createElement(ModalProvider, { backgroundComponent: SpecialModalBackground },
            React.createElement(Modal, { isOpen: isOpen, onRequestClose: toggleModal, style: customStyles, contentLabel: "Product Journey Overlay", overlayClassName: "st-modal-backdrop" },
                React.createElement(IntegrationStackedContent, { isMobile: isMobile, isProductJourney: true }, () => (React.createElement(IntegrationAnalyticsProvider, { productId: productId, gaTrackingId: gaTrackingId },
                    React.createElement(ModalContent, { lang: locale, supplyChain: supplyChain, productId: productId, latestBatch: latestBatch, handleClose: toggleModal }))))))));
};
export default JourneyWidgetContainer;
